import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
  pending: false,
  list: []
});

export function setList(state, data, reset) {
  console.log('Reset?', reset);
  let list;
  if (reset) {
    list = data.data;
  } else {
    list = state.get('list').concat(data.data);
  }
  return state.merge({ list, pending: false });
}

export function setPendingSelf(state, pending = true) {
  return state.set('pending', !!pending);
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'LOGS_PENDING':
      return setPendingSelf(state, action.pending);

    case 'LOGS_LIST':
      return setList(state, action.data, action.reset);

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/logs.js